document.addEventListener('DOMContentLoaded', function () {
  // Selector pentru toate butoanele de wishlist
  const wishlistButtons = document.querySelectorAll('[data-icon-wishlist]');

  // Salvează produsul în localStorage
  wishlistButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const productId = btn.dataset.id;
      const handle = btn.dataset.productHandle;
      let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

      // Nu adăuga dacă e deja în wishlist
      const alreadyExists = wishlist.find((item) => item.id === productId);
      if (!alreadyExists) {
        wishlist.push({ id: productId, handle: handle });
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        alert('Adăugat la favorite!');
      } else {
        alert('Produsul este deja în wishlist.');
      }
    });
  });

  // Afișează wishlist-ul dacă suntem pe pagina de wishlist
  const wishlistContainer = document.querySelector('[data-wishlist-container]');
  if (wishlistContainer) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = '<p>Nu ai produse în wishlist momentan.</p>';
      return;
    }

    wishlist.forEach((item) => {
      // Generează link + buton de ștergere
      const el = document.createElement('div');
      el.classList.add('wishlist-item');
      el.innerHTML = `
        <p><a href="/products/${item.handle}">${item.handle}</a></p>
        <button data-remove-id="${item.id}">Șterge</button>
        <hr>
      `;
      wishlistContainer.appendChild(el);
    });

    // Ștergere din wishlist
    wishlistContainer.querySelectorAll('[data-remove-id]').forEach((btn) => {
      btn.addEventListener('click', function () {
        const id = this.dataset.removeId;
        wishlist = wishlist.filter((item) => item.id !== id);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        location.reload();
      });
    });
  }
});
